export default "/static/dashboard/build/app/img/v2/4db2c1f411221636e0134cf887e333cf.png";